import { ConstraintFilterModel } from "../asset/configuration/constraint-filter.model";
import { LevelModel } from "../asset/emissions/efficiency/level.model";
import { LibraryCollectionModel } from "../asset/emissions/efficiency/library-collection.model";
import { FlareStackModel } from "../asset/emissions/flaring/flare-stack-model";
import { PemsMonthModel } from "../asset/emissions/pems/pems-month.model";
import { PemsYearModel } from "../asset/emissions/pems/pems-year.model";
import { PollutantTypeModel } from "../asset/emissions/pems/pollutant-type-model";
import { SystemModel } from "../asset/inventory/system-model";
import { ChartScale } from "../constants/views/chart-scale-enum";
import { EnergyUnit } from "../constants/views/energy-unit.enum";
import { TenantModel } from "../global/clients/tenant-model";
import { AssetCategorySetModel } from "../tenant/permissions/asset-category-set.model";

export class PageFilterModel {
    public chartName!: string;
    public pageName!: string;
    public pageArea!: string;

    public energyUnit!: EnergyUnit;
    public scale!: ChartScale;

    public initialDate!: Date;
    public endDate!: Date;

    public pollutantType!: PollutantTypeModel;
    public pollutantTypeName!: string;

    public fuelType!: string;

    public flareStack!: FlareStackModel;
    public flareCategorySet!: AssetCategorySetModel;
    public flareCategorySetLevel: number = 1;

    public plainTenant!: string;
    public tenant!: TenantModel;

    public username!: string;

    public powerType!: string;

    public initialDateLocal!: Date;
    public endDateLocal!: Date;

    public ch4Co2eToggle: string = 'ch4';

    public curveType!: string;

    public unitType!: string;
    public system!: string;
    public level!: LevelModel;
    public systemObject!: SystemModel;

    public monthNumber: number = 0;
    public yearNumber: number = (new Date()).getFullYear();

    public injectionLogId!: string;

    public pemsYear!: PemsYearModel;
    public pemsMonth!: PemsMonthModel;
    public fillPollutantWithNullAssets: boolean = false;

    public filterSelections: string[] = [];
    public filterSelectionAlias: string = '';

    public LaeLibraryCollection!: LibraryCollectionModel;

    public constraintFilter: ConstraintFilterModel = new ConstraintFilterModel();

    public filterCriteria: Dictionary<any> = {};
    constructor() { }
}

interface Dictionary<T> {
    [key: string]: T;
}